// **..product-single-accordion js start..**
$(document).ready(function () {
  $(".single-product-accordion-item-title").on("click", function () {
    $(this).next().slideToggle();
    $(this)
      .parent()
      .toggleClass("active")
      .siblings()
      .find(".single-product-accordion-item-content")
      .slideUp();
  });
  $(".accordion-item-title").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
  });
  $(".benefit-item").on("click", function () {
    $(this).toggleClass("active");
    // $(this).addClass('active').siblings().removeClass('active');
    // $(this).siblings().find('.benefits-item-body').slideUp();
    $(this).find(".benefits-item-body").slideToggle();
  });

  if ($(window).width() > 768) {
    $(".image-tab-left-item").on("click", function () {
      var id = $(this).data("id");
      $("#image_tab_" + id)
        .fadeIn()
        .siblings()
        .hide();
      $(this).addClass("active").siblings().removeClass("active");
    });
  }
  if ($(window).width() < 768) {
    $(".tab-item-top").on("click", function () {
      $(this).next().slideToggle();
      $(this)
        .parent()
        .toggleClass("active")
        .siblings()
        .removeClass("active")
        .find(".tab-body-mobile")
        .slideUp();
    });
  }

  // variant option
  $(".variant_option").on("change", function () {
    var vid = $(this).val();
    $("#product_id").val(vid);
    var template = $(".template-name").val();
    let variantName = $(this).data("name");

    $(".variant_selector option").each(function () {
      var txt = $.trim($(this).text());
      if (txt == variantName) {
        $(this).parent().val($(this).val());

        var id = $(".plan_input:checked").val();
        var subs = $(".select-delivery-time option:selected").val();
        var price = $(this).data("price");
        var compare = $(this).data("compare");
        var stock = $(this).data("stock");
        var rate = $(".plan_input:checked").data("rate");
        var bottle = $(".variant_selector option:selected").data("id");
        if (stock) {
          $(".add-to-cart-btn").removeClass("soldout").text("Add To Cart");
        } else {
          $(".add-to-cart-btn").addClass("soldout").text("Sold Out");
        }
        option_change(id, subs, price, compare, rate, bottle, template);
      }
    });
  });

  // quantity plus
  $(document).on("click", ".qty_plus", function () {
    var qty = parseInt($(this).prev().val());
    qty++;
    $(this).prev().val(qty);
    var input = $("#quanity_input_1");
    let price = input.data("price");
    let compare = input.data("compare");
    let rate = input.data("rate");
    let plan = $(".qty_plan:checked").val();
    priceUpdate(price, compare, rate, plan, qty);
  });
  // quantity minus
  $(document).on("click", ".qty_minus", function () {
    var qty = parseInt($(this).next().val());
    if (qty > 1) {
      qty--;
      $(this).next().val(qty);
      var input = $("#quanity_input_1");
      let price = input.data("price");
      let compare = input.data("compare");
      let rate = input.data("rate");
      let plan = $(".qty_plan:checked").val();
      priceUpdate(price, compare, rate, plan, qty);
    }
  });

  // product image slider

  var thumb = new Swiper(".single-product-thumb", {
    loop: true,
    spaceBetween: 6,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesProgress: true,
  });

  var fetured = new Swiper(".single-product-featured", {
    loop: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: thumb,
    },
  });

  // slide text
  var swiper = new Swiper(".textSlider", {
    spaceBetween: 0,
    slidesPerView: 6,
    grabCursor: true,
    loop: true,
    a11y: false,
    freeMode: true,
    speed: 10000,
    // autoplay: {
    //     delay: 0.5,
    //     disableOnInteraction: true,
    // },
    breakpoints: {
      1: {
        slidesPerView: 2,
      },
      576: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 6,
      },
    },
  });

  // brands slider
  var swiper = new Swiper(".brandSlide", {
    spaceBetween: 0,
    grabCursor: true,
    a11y: false,
    freeMode: true,
    speed: 10000,
    loop: true,
    slidesPerView: 6,
    // autoplay: {
    //     delay: 0.5,
    //     disableOnInteraction: false,
    // },
    breakpoints: {
      1: {
        slidesPerView: 2,
      },
      576: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 6,
      },
    },
  });

  // before after
  var swiper = new Swiper(".beforeAfter", {
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  // banner slider js start--
  var swiper = new Swiper(".banner-slider", {
    slidesPerView: 1,
    grabCursor: true,
    loop: false,
    speed: 1000,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    }
  });
  // banner slider js end--

  // best seller slider js start--
  var swiper = new Swiper(".best-sellers-slider", {
    slidesPerView: 4,
    spaceBetween: 20,
    grabCursor: true,
    loop: true,
    speed: 500,
    // autoplay: {
    //     delay: 2500,
    //     disableOnInteraction: false,
    // },
    // pagination: {
    //     el: ".swiper-pagination",
    //     clickable: true,
    // },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      // when window width is >= 320px
      1: {
        slidesPerView: 1,
      },
      // when window width is >= 576px
      576: {
        slidesPerView: 2,
      },
      // when window width is >= 768px
      768: {
        slidesPerView: 3,
      },
      // when window width is >= 993px
      993: {
        slidesPerView: 4,
      },
    },
  });
  // best seller slider js end--

  // review slider js start--
  var swiper = new Swiper(".review-slider", {
    slidesPerView: 4,
    spaceBetween: 20,
    grabCursor: true,
    loop: true,
    speed: 1500,
    // autoplay: {
    //     delay: 1000,
    //     disableOnInteraction: false,
    // },
    breakpoints: {
      // when window width is >= 320px
      1: {
        slidesPerView: 1,
      },
      // when window width is >= 480px
      576: {
        slidesPerView: 2,
      },
      // when window width is >= 767px
      767: {
        slidesPerView: 3,
      },
      // when window width is >= 992px
      992: {
        slidesPerView: 4,
      },
    },
  });
  // review slider js end--

  // blog slider js start--
  var swiper = new Swiper(".blog-slider", {
    slidesPerView: 4,
    spaceBetween: 20,
    grabCursor: true,
    loop: true,
    speed: 1000,
    // autoplay: {
    //     delay: 2500,
    //     disableOnInteraction: false,
    // },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      // when window width is >= 320px
      1: {
        slidesPerView: 1,
      },
      // when window width is >= 480px
      576: {
        slidesPerView: 2,
      },
      // when window width is >= 767px
      767: {
        slidesPerView: 3,
      },
      // when window width is >= 992px
      992: {
        slidesPerView: 4,
      },
    },
  });
  // blog slider js end--

  // bundle

  // **..product-single2 js start..**
  $(document).ready(function () {
    $(".choose-single-product-flaver-item").on("click", function () {
      $(this).toggleClass("active");
      $(this).siblings().removeClass("active");
    });
  });

  // tab-accordion js start--
  $(".faq-tab-nav-item:first-child").addClass("active");
  $(".faq-tab-content-item").hide();
  $(".faq-tab-content-item:first").show();

  $(".faq-tabs-nav-item-link").click(function () {
    $(".faq-tab-nav-item").removeClass("active");
    $(this).parent().addClass("active");
    $(".faq-tab-content-item").hide();

    var activeTab = $(this).attr("href");
    $(activeTab).fadeIn();
    return false;
  });
  // tab-accordion js end--

  // **..faq-accordion js start..**
  $(".accordion-toggle-btn").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
    $(this)
      .parent()
      .siblings()
      .removeClass("active")
      .find(".faq-accordion-item-content")
      .slideUp();
  });
});

$(document).ready(function () {
  $(".quanity_input").on("change", function () {

    var qty = $(this).val();
    let price = $(this).data("price");
    let compare = $(this).data("compare");
    let rate = $(this).data("rate");
    let plan = $(".qty_plan:checked").val();
    // let rate = $('.plan_input').data('rate');
    priceUpdate(price, compare, rate, plan, qty);
    $(".single-product-quantity-total-input").val(qty);
  });

  $(document).on("change", ".qty_plan", function () {
    $(this).parent().addClass("active").siblings().removeClass("active");
    var id = $(this).val();
    var input =  $(".quanity_input:checked");
    var qty = $(".single-product-quantity-total-input").val();
    let price = input.data("price");
    let compare = input.data("compare");
    let rate = input.data("rate");
    let plan = id;
    // let rate = $('.plan_input').data('rate');
    priceUpdate(price, compare, rate, plan, qty);

    var subs = $(".select-delivery-time option:selected").val();
    if (id == 1) {
      $("#selling_plan").val(subs);
      // $('.total-value, .value_price').show();
    } else {
      $("#selling_plan").val("");
      // $('.total-value, .value_price').hide();
    }
  });
});

function priceUpdate(price, compare, rate, plan, qty) {
  let final_price = price * 0.01 * rate;
  final_price = (final_price * qty).toFixed(2);
  price = price * qty;
  price = (price * 0.01).toFixed(2);
  compare = compare * qty;
  compare = (compare * 0.01).toFixed(2);
  let x = 0.65;

  if (qty >= 2) {
    $(".subs_price").text(currency + (final_price * x).toFixed(2));
    $(".onetime_price").text(currency + (price * x).toFixed(2));
    if (compare > price) {
      var save = compare - final_price * x;
    } else {
      var save = price - final_price * x;
    }
    $(".qty_discount").text("Save " + currency + save.toFixed());
  } else {
    $(".subs_price").text(currency + final_price);
    $(".onetime_price").text(currency + price);

    if (compare > price) {
      var save = (compare - final_price).toFixed();
    } else {
      var save = (price - final_price).toFixed();
    }

    $(".qty_discount").text("Save " + currency + save);
  }


  if (plan == 1) {
    if (qty >= 2) {
      $(".reg_cost").text(currency + (final_price * x).toFixed(2));
    } else {
      $(".reg_cost").text(currency + final_price);
    }
    $(".total-value").show();
    if (compare > 0) {
      $(".value_price")
        .show()
        .text(currency + compare);
    } else {
      $(".value_price")
        .show()
        .text(currency + price);
    }
  } else {
    if (compare > price) {
      $(".total-value").show();
      $(".")
        .show()
        .text(currency + compare);
    } else {
      $(".value_price").hide();
      $(".total-value").hide();
    }

    if (qty >= 2) {
      $(".reg_cost").text(currency + (price * x).toFixed(2));
      $(".total-value").show();
      $(".value_price")
        .show()
        .text(currency + price);
    } else {
      $(".reg_cost").text(currency + price);
    }
  }


  if (qty >= 2) {
    $(".gift-items").show();
    $(".quanity_input").prop("checked", false); // Uncheck all first
    $("#quanity_input_2").prop("checked", true).attr("checked", "checked");
  } else if (qty == 1) {
    $(".gift-items").hide();
    $(".quanity_input").prop("checked", false); // Uncheck all first
    $("#quanity_input_1").prop("checked", true).attr("checked", "checked");
  }

  let progress = 0;
  let discount = $('#discount').val();
  if (qty == 1) {
      progress = 50;
      $('.discont-text').text('You’re '+ (2 - qty) +' item away from an additional discount')
  } else if (qty >= 2) {
      progress = 100;
      $('.discont-text').text('Congratulations! You got a '+ discount +'% discount.')
  }

  $(".progress em").css("width", progress + "%");
}
